export type CameraStartFailure = 'denied' | 'not-found' | 'in-use' | 'unsupported' | 'unknown'

// qr-scanner 는 getUserMedia 의 DOMException 을 그대로 던지기도 하고, 카메라를 못 찾으면 문자열을 던진다
export const classifyCameraStartError = (error: unknown): CameraStartFailure => {
  if (typeof navigator !== 'undefined' && !navigator.mediaDevices?.getUserMedia) {
    return 'unsupported'
  }
  const name = error instanceof Error || error instanceof DOMException ? error.name : undefined
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'denied'
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'not-found'
    case 'NotReadableError':
    case 'AbortError':
      return 'in-use'
  }
  if (typeof error === 'string' && error.includes('Camera not found')) return 'not-found'
  return 'unknown'
}

export type ImageSize = { width: number; height: number }

/**
 * 사진은 원본 해상도(8~12MP)에서 한 번도 인식되지 않았고 원본 단계에서 worker 가 10초 가까이
 * 멈추기도 해서(실기기 측정), 큰 사진은 원본을 건너뛰고 긴 변 기준으로 줄여 가며 시도한다
 */
export const getPhotoDecodeSizes = (
  { width, height }: ImageSize,
  maxSides: number[] = [1600, 800],
): ImageSize[] => {
  const longSide = Math.max(width, height)
  const sizes = maxSides
    .filter((maxSide) => maxSide < longSide)
    .map((maxSide) => ({
      width: Math.round((width * maxSide) / longSide),
      height: Math.round((height * maxSide) / longSide),
    }))
  return longSide > Math.max(...maxSides) ? sizes : [{ width, height }, ...sizes]
}
